<template>
  <div v-if="preorder && preorder.orders" id="PaymentPage">
    <div v-for="order in preorder.orders" :key="order.shopId">
      <SfHeading
        :level="3"
        :title="order.shop.title"
        class="sf-heading--left sf-heading--no-underline title"
      />
      <SfTable class="sf-table--bordered table desktop-only">
        <SfTableHeading class="table__row">
          <!-- <SfTableHeader class="table__header">{{
            $t('Item')
            }}</SfTableHeader> -->
          <SfTableHeader
            v-for="tableHeader in tableHeaders"
            :key="tableHeader.text"
            class="table__header"
            :class="{ table__description: tableHeader.text === 'Description' }"
            :style="{ flex: tableHeader.flex }"
          >
            {{ $t(tableHeader.text) }}
          </SfTableHeader>
          <!-- <SfTableHeader style="text-align: center;width:50px;flex:none;"> {{ $t('operate') }} </SfTableHeader> -->
        </SfTableHeading>
        <div v-for="(product, index) in order.orderItem" :key="index">
          <SfTableRow class="table__row">
            <SfTableData style="flex: 1">
              <SfImage
                :src="addBasePath(orderGetters.getItemImg(product))"
                :alt="orderGetters.getItemName(product)"
                class="orderImg"
                style="margin-right: 0.5rem"
              />
            </SfTableData>
            <SfTableData colspan="6" style="flex: 6; padding-left: 5px">
              <div class="table__row" style="width: 100%; display: flex">
                <SfTableData
                  class="table__data table__description table__data"
                  style="flex: 5"
                >
                  <div class="product-title">
                    {{ orderGetters.getItemName(product) }}
                  </div>
                  <div class="product-sku">
                    <div
                      v-for="(skuVal, key) in orderGetters.getItemAttributes(
                        product
                      )"
                      style="margin-right: 5px"
                    >
                      {{ key }}: {{ skuVal }}
                    </div>
                  </div>
                </SfTableData>
                <div style="flex: 1">
                  <div style="display: flex">
                    <SfTableData class="table__data">
                      <SfQuantitySelector
                        :qty="product.num"
                        @input="changeNum($event, product)"
                      />
                    </SfTableData>
                  </div>
                </div>
              </div>
            </SfTableData>
            <div style="width: 100%;">
              <div class="sf-table__row" style="padding:var(--spacer-xs) 0;border:0;">
                <div class="table-col" style="width: 7rem"></div>
                <div class="table-col" style="flex: 1">
                  <div>
                    <!-- 'Price', 'Discount', 'TaxFee', 'Amount' -->
                    <div class="table-label">{{ $t('Price') }}</div>
                    <div style="display: flex; justify-content: start">
                      <SfPrice :regular="$n(product.price, 'currency')">
                      </SfPrice>
                    </div>
                  </div>
                </div>
                <div class="table-col" style="flex: 1">
                  <div class="table-label">{{ $t('Discount') }}</div>
                  <div style="display: flex; justify-content: start;align-items:baseline;">
                    -
                    <SfPrice :regular="$n(product.discount, 'currency')">
                    </SfPrice>
                  </div>
                </div>
                <div class="table-col"  style="flex: 1">
                  <div class="table-label">{{ $t('TaxFee') }}</div>
                  <div style="display: flex; justify-content: start;align-items:baseline;">
                    +
                    <SfPrice :regular="$n(product.taxFee, 'currency')">
                    </SfPrice>
                  </div>
                </div>
                <div class="table-col"  style="flex: 1">
                  <div class="table-label">{{ $t('Amount') }}</div>
                  <div>
                    <Sf-price
                      :regular="
                        $n(
                          orderGetters.getItemAgnosticPrice(product).regular,
                          'currency'
                        )
                      "
                      :special="
                        orderGetters.getItemAgnosticPrice(product).special &&
                        $n(orderGetters.getItemAgnosticPrice(product).special)
                      "
                      class="product-price"
                    />
                  </div>
                </div>
                <div class="table-col"  style="flex: 1;">
                  <div class="table-label" style="text-align: right;">{{ $t('operate') }}</div>
                  <div style="display: flex;justify-content: end;height: 28px;">
                    <SfButton
                      v-if="order.orderItem && order.orderItem.length > 1"
                      @click="RemoveProduct(product)"
                      class="sf-button--text"
                      >{{ $t('Delete') }}</SfButton
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                preorder.goodsService &&
                preorder.goodsService[order.shopId] &&
                preorder.goodsService[order.shopId][product.skuId]
              "
              style="
                width: 100%;
                border-top: 1px solid #ccc;
                margin-top: 0.5rem;
                padding-top: 1rem;
                padding-bottom: 1rem;
              "
              class="goodService"
            >
              <div
                v-for="goodService in preorder.goodsService[order.shopId][
                  product.skuId
                ]"
                class="table__row"
                style="display: flex; width: 100%; justify-content: flex-start;margin-bottom:0.5rem;align-items: center;"
              >
                <div class="table__image2" style="width: var(--image-width);display: flex;align-items: flex-end;">
                  <Sf-checkbox
                    v-e2e="'service_name'"
                    v-model="servicesList[product.skuId]"
                    :name="product.skuId + ''"
                    @change="
                      toggleServices(
                        product.skuId + '',
                        servicesList[product.skuId]
                      )
                    "
                    :value="goodService.service_id + ''"
                  >
                    <template #label>
                      <div class="sf-checkbox__label">
                        {{ goodService.service_name }}
                      </div>
                    </template>
                  </Sf-checkbox>
                </div>
                <div
                  class="table__data "
                  style="display: flex; flex: 1; align-items: flex-end"
                >
                  <div
                    class="sf-checkbox__label"
                    style=" margin-left: 0;text-align: left;"
                  >
                    {{ goodService.description }}
                  </div>
                </div>
                <div
                  class="table__data"
                  style="
                    display: flex;
                    align-items: flex-end;
                    text-align: right;
                  "
                >
                  <div
                    class="sf-checkbox__label"
                    style="width: 100%"
                  >
                    {{ $n(goodService.price, 'currency') }}
                  </div>
                </div>
              </div>
            </div>
          </SfTableRow>
        </div>
      </SfTable>
      <SfTable class="sf-table--bordered table mobile-only">
        <SfTableHeading class="table__row" v-if="mobileTableHeaders">
          <SfTableHeader
            v-for="tableHeader in mobileTableHeaders"
            :key="tableHeader"
            class="table__header"
          >
            {{ $t(tableHeader) }}
          </SfTableHeader>
        </SfTableHeading>
        <div v-for="(product, index) in order.orderItem"
          :key="index">
          <SfTableRow
            class="table__row"
          >
            <SfTableData style="flex: 1">
              <SfImage
                :src="addBasePath(orderGetters.getItemImg(product))"
                :alt="orderGetters.getItemName(product)"
                class="orderImg"
              />
            </SfTableData>
            <SfTableData colspan="3" style="flex: 3; padding-left: 5px">
              <div class="sf-table__row" style="border:0;">
                <div class="table-col">
                  <div class="product-title">
                    {{ orderGetters.getItemName(product) }}
                  </div>
                  <div class="product-sku">
                    <div
                      v-for="(skuVal, key) in orderGetters.getItemAttributes(
                        product
                      )"
                      style="margin-right: 5px"
                    >
                      {{ key }}: {{ skuVal }}
                    </div>
                  </div>
                </div>
                <div
                  class="table-col"
                  style="display: flex; justify-content: end"
                >
                  <div style="text-align: right">
                    <SfQuantitySelector
                      :qty="product.num"
                      @input="changeNum($event, product)"
                    />
                    <SfButton
                      v-if="order.orderItem && order.orderItem.length > 1"
                      @click="RemoveProduct(product)"
                      class="sf-button--text"
                      >{{ $t('Delete') }}</SfButton
                    >
                  </div>
                </div>
              </div>
            </SfTableData>
          </SfTableRow>
          <Sf-TableRow class="table__row">
            <div style="width: 100%;">
                <SfList>
                  <SfListItem class="sf-table__row list-price">
                    {{ $t('Price') }}:
                    <SfPrice :regular="$n(product.price, 'currency')">
                    </SfPrice>
                  </SfListItem>
                  <SfListItem class="sf-table__row list-price">
                    {{ $t('Discount') }}:
                    <SfPrice :regular="'-' + $n(product.discount, 'currency')">
                    </SfPrice>
                  </SfListItem>
                  <SfListItem class="sf-table__row list-price">
                    {{ $t('Tax') }}:
                    <SfPrice :regular="$n(product.taxFee, 'currency')"> </SfPrice>
                  </SfListItem>
                  <SfListItem class="sf-table__row list-price">
                    {{ $t('Amount') }}:
                    <SfPrice :regular="$n(product.totalPayment, 'currency')">
                    </SfPrice>
                  </SfListItem>
                  <SfListItem class="sf-table__row list-price"> </SfListItem>
                </SfList>
                <SfList
                  style="
                    width: 100%;
                    border-top: 1px solid #ccc;
                    margin-top: 0.5rem;
                  "
                >
                  <template
                    v-if="
                      preorder.goodsService &&
                      preorder.goodsService[order.shopId] &&
                      preorder.goodsService[order.shopId][product.skuId]
                    "
                  >
                    <template
                      v-for="goodService in preorder.goodsService[order.shopId][
                        product.skuId
                      ]"
                      class="table__row"
                      style="
                        display: flex;
                        width: 100%;
                        justify-content: flex-start;
                      "
                    >
                      <SfListItem class="sf-table__row list-price">
                        <Sf-checkbox
                          v-e2e="'service_name'"
                          v-model="servicesList[product.skuId]"
                          :name="product.skuId + ''"
                          class="summary__terms"
                          @change="
                            toggleServices(
                              product.skuId + '',
                              servicesList[product.skuId]
                            )
                          "
                          :value="goodService.service_id + ''"
                        >
                          <template #label>
                            <div style="margin-left: 5px">
                              {{ goodService.service_name }}
                            </div>
                          </template>
                        </Sf-checkbox>
                        <div class="summary__terms" style="margin: 0.5rem 0">
                          <div class="sf-checkbox__label" style="margin-left: 0">
                            {{ goodService.description }}
                          </div>
                        </div>
                      </SfListItem>
                      <SfListItem class="sf-table__row list-price">
                        {{ $t('Services_Price') }}:
                        <div style="display: flex; align-items: flex-end">
                          <div class="sf-checkbox__label">
                            {{ $n(goodService.price, 'currency') }}
                          </div>
                        </div>
                      </SfListItem>
                      <!-- <div class="table__image" style="width:var(--image-width);">
                        <SfCheckbox v-e2e="'service_name'" v-model="servicesList[product.skuId]" :name="product.skuId + ''" class="summary__terms"
                          @change="toggleServices(product.skuId + '', servicesList[product.skuId])" :value="goodService.service_id + ''">
                          <template #label>
                            <div class="sf-checkbox__label">
                              {{ goodService.service_name }}
                            </div>
                          </template>
                        </SfCheckbox>
                      </div> -->
                      <!-- <div class="table__data table__description table__data">
                        {{ goodService.description }}
                      </div>
                      <div class="table__data table__description">
                        {{ goodService.price }}
                      </div> -->
                    </template>
                  </template>
                </SfList>
              </div>
          </Sf-TableRow>
        </div>
      </SfTable>
      <VsfShippingProvider
        @submit="router.push(localePath({ name: 'billing' }))"
        :addressId="address.addressId"
        :shopId="order.shopId"
      />
      <div style="margin-top: 20px" class="summary" v-if="order.postFee > 0">
        <div class="summary__group">
          <div class="summary__total">
            <SfProperty
              :name="$t('payment_post_fee')"
              :value="$n(order.postFee > 0 ? order.postFee : 0, 'currency')"
              class="sf-property--full-width property"
            />
          </div>
        </div>
      </div>
      <div style="margin-top: 20px" class="summary" v-if="order.postFeeTax > 0">
        <div class="summary__group">
          <div class="summary__total">
            <SfProperty
              :name="$t('payment_post_tax')"
              :value="
                $n(order.postFeeTax > 0 ? order.postFeeTax : 0, 'currency')
              "
              class="sf-property--full-width property"
            />
          </div>
        </div>
      </div>
      <div v-if="InsuranceShow" style="border-top: 1px solid #ccc">
        <SfCheckbox
          v-if="InsuranceShow"
          v-e2e="'hasInsurance'"
          v-model="hasInsurance"
          name="hasInsurance"
          class="summary__terms"
          @change="toggleInsurance"
        >
          <template #label>
            <div class="sf-checkbox__label">
              {{ $t('hasInsurance') }}
            </div>
          </template>
        </SfCheckbox>
        <div
          style="margin-top: 20px"
          class="summary"
          v-if="order.insuranceFee > 0"
        >
          <div class="summary__group">
            <div class="summary__total">
              <SfProperty
                :name="$t('payment_insurance_fee')"
                :value="
                  $n(
                    order.insuranceFee > 0 ? order.insuranceFee : 0,
                    'currency'
                  )
                "
                class="sf-property--full-width property"
              />
            </div>
          </div>
        </div>
        <div
          style="margin-top: 20px"
          class="summary"
          v-if="order.insuranceTax > 0"
        >
          <div class="summary__group">
            <div class="summary__total">
              <SfProperty
                :name="$t('payment_insurance_tax')"
                :value="
                  $n(
                    order.insuranceTax > 0 ? order.insuranceTax : 0,
                    'currency'
                  )
                "
                class="sf-property--full-width property"
              />
            </div>
          </div>
        </div>
      </div>
      <div style="border-top: 1px solid #ccc; margin-top: 1rem">
        <div style="margin-top: 20px" class="summary" v-if="order.discount > 0">
          <div class="summary__group">
            <div class="summary__total">
              <SfProperty
                :name="$t('payment_order_discount')"
                :value="
                  '-' + $n(order.discount > 0 ? order.discount : 0, 'currency')
                "
                class="sf-property--full-width property"
              />
            </div>
          </div>
        </div>
        <div style="margin-top: 20px" class="summary">
          <div class="summary__group">
            <div class="summary__total">
              <SfProperty
                :name="$t('payment_order_total')"
                :value="$n(order.payment > 0 ? order.payment : 0, 'currency')"
                class="sf-property--full-width property"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="summary">
      <div class="summary__group">
        <div v-if=isShowEmail>
          <SfDivider />
          <SfProperty
            style="margin-top: var(--spacer-sm)"
            :name="$t('email')"
            class="sf-property--full-width property emailRow"
          >
            <template #value>
              <div>
                <SfInput :required="isShowEmail" v-model="email" name="email"
                      class="form__element form__element--half emailInput" @change="OrderEmailChange" />
              </div>
            </template>
          </SfProperty>
          <SfDivider />
        </div>
        <div>
          <SfDivider />
          <SfProperty
            style="margin-top: var(--spacer-sm)"
            :name="$t('payment_order_note')"
            class="sf-property--full-width property OrderNoteRow"
          >
            <template #value>
              <div>
                <SfTextarea
                  :value="orderNote"
                  name="orderNote"
                  class="orderNote"
                  type="text"
                  :icon="{ icon: '', color: '', size: '' }"
                  valid
                  :cols="28"
                  :required="false"
                  :disabled="false"
                  @change="OrderNoteChange"
                  :hasShowPassword="false"
                  placeholder=""
                  v-model="orderNote"
                />
              </div>
            </template>
          </SfProperty>
          <SfDivider />
          <!-- <SfProperty
            name="Payment price"
            :value="$n(preorder.taxFee, 'currency')"
            class="sf-property--full-width sf-property--large summary__property-total"
          /> -->
        </div>
        <div v-if="preorder.orders && preorder.orders.length > 1">
          <SfDivider />
          <SfProperty
            :name="$t('payment_order_total')"
            :value="$n(preorder.totalCount, 'currency')"
            class="sf-property--full-width sf-property--large summary__property-total"
          />
          <SfDivider />
          <SfProperty
            :name="$t('payment_order_payment')"
            :value="$n(preorder.payment, 'currency')"
            class="sf-property--full-width sf-property--large summary__property-total"
          />
          <SfDivider />
          <!-- <SfProperty
            name="Payment price"
            :value="$n(preorder.taxFee, 'currency')"
            class="sf-property--full-width sf-property--large summary__property-total"
          /> -->
        </div>
        <!-- <VsfPaymentProvider @status="isPaymentReady = true" /> -->
        <div class="mobile-only">
          <CartPreview key="order-summary" />
        </div>
        <SfCheckbox
          v-e2e="'terms'"
          v-model="terms"
          name="terms"
          class="summary__terms"
        >
          <template #label>
            <div class="sf-checkbox__label">
              {{ $t('payment_agree_1') }}
              <SfLink href="#" :link="{}"> {{ $t('payment_agree_2') }}</SfLink>
            </div>
          </template>
        </SfCheckbox>

        <div v-e2e="'payment-summary-buttons'" class="summary__action">
          <SfButton
            :disabled="
              loading ||
              createLodding ||
              !terms ||
              (preOrderErr && preOrderErr.load != null) ||
              (preorder && preorder.errs && preorder.errs.length != 0)
            "
            class="summary__action-button"
            @click="processOrder"
          >
            {{ $t('payment_make_order') }}
          </SfButton>

          <SfButton
            type="button"
            class="sf-button color-secondary summary__back-button"
            @click="router.push(localePath('/checkout/billing'))"
          >
            {{ $t('Go_back') }}
          </SfButton>
        </div>
      </div>
    </div>
    <confirmModal
      ref="deleProduct"
      @ok="okDelectProduct"
      @close="cancelProduct"
    ></confirmModal>
  </div>
</template>

<script>
import {
  SfHeading,
  SfTable,
  SfCheckbox,
  SfButton,
  SfDivider,
  SfImage,
  SfIcon,
  SfPrice,
  SfProperty,
  SfAccordion,
  SfLink,
  SfList,
  SfTextarea,
  SfQuantitySelector,
  SfCircleIcon,
  SfInput
} from '@storefront-ui/vue';
import confirmModal from '~/components/ContentModal/confirm';
import { ref, computed, useRouter } from '@nuxtjs/composition-api';
import { useOCart, cartGetters, usePreviewOrder, orderGetters, useOrderCreate, useCredential, useUser, useApiError } from '@bee-hole/coms';
import { addBasePath } from '@vue-storefront/core';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import VsfShippingProvider from '~/components/Checkout/VsfShippingProvider';
import CartPreview from '~/components/Checkout/CartPreview';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'ReviewOrder',
  components: {
    SfHeading,
    SfTable,
    SfCheckbox,
    SfButton,
    SfDivider,
    SfImage,
    SfIcon,
    SfPrice,
    SfProperty,
    SfAccordion,
    SfLink,
    VsfShippingProvider,
    CartPreview,
    SfList,
    SfTextarea,
    SfQuantitySelector,
    SfCircleIcon,
    confirmModal,
    SfInput
    // VsfPaymentProvider: () => import('~/components/Checkout/VsfPaymentProvider')
  },
  setup(p, { root }) {
    const router = useRouter();
    const { cart, load, clear: clearCart, updateItemQty, removeItem } = useOCart();
    // const { make, loading } = useMakeOrder();
    // const { cart, removeItem, updateItemQty, loading, load, clear } =
    //   useOCart();
    const { set: setError } = useApiError();
    const { user, loadUser } = useUser();
    const { preorder, loading, error: preOrderErr } = usePreviewOrder();
    const { create, result: orderRes } = useOrderCreate();
    const createLodding = ref(false);
    const terms = ref(false);
    const previewOrderStore = usePreviewOrderStore();
    const address = computed(() => previewOrderStore.address);
    const { getPinJu, result: pingju } = useCredential();
    const hasInsurance = ref(previewOrderStore.hasInsurance || false);
    // console.log('preorder.services', previewOrderStore.services);
    const servicesList = ref(previewOrderStore.services || {});
    const orderNote = ref(previewOrderStore.orderNote || '');
    const email = ref(previewOrderStore.email || '');
    const InsuranceShow = computed(() => root.$options?.$storeConfig?.mall_insurance_enable === '1');
    const deleProduct = ref();
    const currentProduct = ref();
    const isShowEmail = computed(() => user.value?.email.indexOf("@guest.com") !== -1);
    const shoppingList = (() => {
      const list = [];
      cart?.value?.list?.map((item) => {
        const sku = {
          sku_id: item.skuId,
          num: item.num,
          sku_prop: item.properties,
          activity_id: ''
        };
        if (servicesList.value?.[item.skuId]) {
          sku.service_ids = servicesList.value?.[item.skuId];
        }
        list.push(sku);
      });
      return list;
    });
    const validateEmail = (email)=> {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    const googleBeginChckout = ()=>{
      root.$gtm.push({
        event: "begin_payment",
        ecommerce: null,
      });
      const googleItem ={
        event: "begin_payment",
        ecommerce: {
          currency: root?.$cookies?.get('vsf-currency'),
          value: preorder.value?.payment,
          items: [
          ]
        }
      }
      preorder.value?.orders?.map((order)=>{
        order?.orderItem?.map((product)=>{
          googleItem.ecommerce.items.push({
            item_id: product.goodId,
            item_name: product.title,
            discount: product.discount,
            item_variant: product.skuProp,
            price: product.price,
            quantity: product.num
          })
        })
      })
      root.$gtm.push(googleItem);
    }
    const processOrder = async () => {
      // const data = { scene_type: 'NATIVE', order_id: preorder.value.orderId };
      // await make({ customQuery: data });
      // clearCart();
      // previewOrderStore.clearPrepayId();
      // previewOrderStore.clearIdCard();
      // const thankYouPath = { name: 'thank-you', query: { order: orderGetters.getId(order.value) } };
      // router.push(root.localePath(thankYouPath));
      if (isShowEmail.value && email.value && !validateEmail(email.value)) {
        setError({ message: root.$t('emailError'), code: 500 });
        return false;
      }
      if (createLodding.value) {
        return false;
      }
      createLodding.value = true;
      const userKey = root?.$cookies.get("userKey");
      const tokenkey = root?.$cookies.get("tokenkey");
      const data = {
        address_id: previewOrderStore?.address?.addressId,
        fx_id: '0',
        from_id: tokenkey,
        member_note: orderNote.value,
        shopping_list: shoppingList(),
        combine_pay: true,
        billing_address_id: previewOrderStore?.builing?.addressId,
        is_pick_up_order: false,
        has_insurance: hasInsurance.value,
        email: email.value
      };
      if (userKey) {
        data.user_id = userKey;
      }
      if (previewOrderStore.shippingMethods && preorder.value && previewOrderStore.shippingMethods.length === preorder.value?.orders?.length) {
        data.express = previewOrderStore.shippingMethods;
      }
      if (previewOrderStore?.preview_id) {
        data.preview_id = previewOrderStore?.preview_id;
      }
      // if (promoCode?.value) {
      //   data.promo_code = promoCode?.value;
      // }
      // 传入store的previewkey
      if (previewOrderStore?.previewKey) {
        data.preview_serial_id = previewOrderStore?.previewKey;
      }
      if (previewOrderStore?.IdCard && previewOrderStore?.IdCard?.id_number && previewOrderStore?.IdCard?.id_name) {
        data.id_name = previewOrderStore.IdCard.id_name;
        data.id_number = previewOrderStore.IdCard.id_number;
        data.id_type = previewOrderStore.IdCard.id_type;
      } else if (previewOrderStore?.IdCard?.id_type || previewOrderStore?.IdCard?.id_number || previewOrderStore?.IdCard?.id_name) {
        // return false;
      }
      await create(data);
      if (orderRes?.value?.prepay_id) {
        await getPinJu({ prepay_id: orderRes?.value?.prepay_id });
        if (email.value) {
          await loadUser();
        }
        if (pingju.value?.credential_id) {
          const transformedPath = `/xpay?orderNumber=${orderRes?.value?.prepay_id}&credential_id=${pingju.value?.credential_id}`;
          previewOrderStore.ClearPreviewOrderInfo();
          await clearCart();
          await load();
          googleBeginChckout();
          router.push(root.localePath(transformedPath));
        } else {
          createLodding.value = false;
        }
      } else {
        createLodding.value = false;
      }

      // const pay = { name: 'xpay', query: { orderNumber: preorder.value.orderId } };
      // router.push(root.localePath(pay));
    };
    const toggleServices = (skuid, has) => {
      // console.log('e', skuid, has, servicesList.value);
      previewOrderStore.setServices(skuid, (servicesList.value[skuid]));
      EventBus.$emit('PreviewOrder', (servicesList.value[skuid]));
    };
    const toggleInsurance = () => {
      previewOrderStore.sethasInsurance(hasInsurance.value);
      EventBus.$emit('PreviewOrder', hasInsurance.value);
    };
    const OrderNoteChange = (e) => {
      orderNote.value = e.target.value;
      previewOrderStore.setOrderNote(orderNote.value);
      EventBus.$emit('PreviewOrder', orderNote.value);
    };
    const OrderEmailChange = (e) => {
      email.value = e.target.value;
      previewOrderStore.setOrderEmail(email.value);
      EventBus.$emit('PreviewOrder', email.value);
    };
    const changeNum = async (qty, product) => {
      await updateItemQty({ product: { Id: product.goodId, skuId: product.skuId }, quantity: qty });
      EventBus.$emit('PreviewOrder', cart.value);
    };
    const RemoveProduct = async (product) => {
      currentProduct.value = product;
      deleProduct.value.setModal({
        title: root.$t('removeCartItem'),
        context: root.$t('removeCartItemContext', { title: product.title })
      });
    };
    const okDelectProduct = async () => {
      if (currentProduct.value && currentProduct.value.goodId) {
        await removeItem({
          customQuery: { id: currentProduct.value.goodId, sku_id: currentProduct.value.skuId }
        });
        EventBus.$emit('PreviewOrder', cart.value);
      }
    };
    const cancelProduct = () => {
      currentProduct.value = null;
    };
    return {
      addBasePath,
      router,
      // isPaymentReady,
      terms,
      loading,
      products: computed(() => cartGetters.getItems(cart.value)),
      totals: computed(() => cartGetters.getTotals(cart.value)),
      // , 'Price', 'Discount', 'TaxFee', 'Amount'
      tableHeaders: [{ text: 'item', flex: 1 }, { text: 'Description', flex: 5 }, { text: 'Quantity', flex: 1 }],
      mobileTableHeaders: ['item', 'Description', 'Quantity'],
      cartGetters,
      processOrder,
      preorder,
      orderGetters,
      address,
      preOrderErr,
      hasInsurance,
      toggleInsurance,
      createLodding,
      InsuranceShow,
      servicesList,
      toggleServices,
      orderNote,
      OrderNoteChange,
      changeNum,
      RemoveProduct,
      okDelectProduct,
      cancelProduct,
      currentProduct,
      deleProduct,
      email,
      OrderEmailChange,
      isShowEmail
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin: var(--spacer-xl) 0 var(--spacer-base) 0;
}

.table {
  margin: 0 0 var(--spacer-base) 0;

  &__row {
    justify-content: space-between;
  }

  @include for-desktop {
    &__header {
      text-align: center;

      &:last-child {
        text-align: right;
      }
    }

    &__data {
      text-align: center;
    }

    &__description {
      text-align: left;
      flex: 0 0 12rem;
    }

    &__image {
      --image-width: 5.125rem;
      text-align: left;
      margin: 0 var(--spacer-xs) 0 0;
    }
  }
}

.product-sku {
  color: var(--c-text-muted);
  font-size: var(--font-size--sm);
  display: flex;
  flex-wrap: wrap;
}

.price {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.product-price {
  --price-font-size: var(--font-size--base);
}

.summary {
  &__terms {
    margin: var(--spacer-base) 0 0 0;
  }

  &__total {
    margin: 0 0 var(--spacer-sm) 0;
    flex: 0 0 16.875rem;
  }

  &__action {
    @include for-desktop {
      display: flex;
      margin: var(--spacer-xl) 0 0 0;
    }
  }

  &__action-button {
    margin: 0;
    width: 100%;
    margin: var(--spacer-sm) 0 0 0;

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
      width: auto;
    }

    &--secondary {
      @include for-desktop {
        text-align: right;
      }
    }
  }

  &__back-button {
    margin: var(--spacer-sm) 0 0 0;
    width: 100%;

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
      width: auto;
    }

    color: var(--c-white);

    &:hover {
      color: var(--c-white);
    }
  }

  &__property-total {
    margin: var(--spacer-xl) 0 0 0;
  }
}

.property {
  margin: 0 0 var(--spacer-sm) 0;

  &__name {
    color: var(--c-text-muted);
  }
}

.accordion {
  margin: 0 0 var(--spacer-xl) 0;

  &__item {
    display: flex;
    align-items: flex-start;
  }

  &__content {
    flex: 1;
  }

  &__edit {
    flex: unset;
  }
}

.content {
  margin: 0 0 var(--spacer-xl) 0;
  color: var(--c-text);

  &:last-child {
    margin: 0;
  }

  &__label {
    font-weight: var(--font-weight--normal);
  }
}

.table__data.table__description {
  text-align: left;
}

.table__data {
  text-align: center;
}

@media (max-width: 1023px) {
  .mobile-only {
    display: block;
  }
}

@media (min-width: 1023px) {
  .mobile-only {
    display: none;
  }
}

.orderImg {
  --_image-width: 5rem;
}

.summary__property-total {
  margin: var(--spacer-sm) 0 0 0;
}
</style>
<style lang="scss">
#PaymentPage{
  .table-label{
    margin-bottom: 1rem;
    color: var(--c-text-muted);
  }
  .goodService{
    .sf-checkbox__message{
      display: none;
    }
  }
  .emailInput{
    input{
      border: 1px solid var(--c-text);
      padding: 1rem;
    }
    @include for-mobile {
      width: 100%;
    }
    @include for-desktop {
      width: 100%;
      input{
        width: 17.2rem;
      }
    }
  }
}
@media (min-width: 1023px) {
  .table__image {
    --image-width: 5.125rem;
    text-align: left;
    margin: 0 0 0 0;

    .sf-image--placeholder {
      width: var(--image-width) !important;
    }
  }
  .table__image2 {
    --image-width: 7.625rem;
    text-align: left;
    margin: 0 0 0 0;

    .sf-image--placeholder {
      width: var(--image-width) !important;
      max-width: var(--image-width) !important;
    }

    .sf-checkbox__checkmark {
      min-width: 24px;
      min-height: 24px;
    }
  }
}
@media (min-width: 1024px) {
  .table__image {
    margin: 0 0 0 0 !important;
  }
}
@media (max-width: 1023px) {
  .product-title {
    text-align: left;
  }

  .table__row {
    display: block;
  }

  .sf-table__row {
    display: flex;
  }

  .table__header,
  .table-col {
    text-align: center;
    flex: 1;
    // 文字换行
    word-break: break-all;
    word-wrap: break-word;
    // order:0
  }

  .sf-table__data:nth-child(3n-1),
  .sf-table__header:nth-child(3n-1) {
    order: 0;
  }

  .table__header:last-child {
    text-align: right;
    // order:0
  }

  .table__image {
    --image-width: 5.125rem;
    text-align: left;
    margin: 0 0 0 0;

    .sf-image--placeholder {
      width: var(--image-width) !important;
    }
  }
  .table__image2 {
    --image-width: 7.625rem;
    text-align: left;
    margin: 0 0 0 0;

    .sf-image--placeholder {
      width: var(--image-width) !important;
      max-width: var(--image-width) !important;
    }

    .sf-checkbox__checkmark {
      min-width: 24px;
      min-height: 24px;
    }
  }
  .orderImg {
    width: 5rem;
    --_image-width: 5rem;
    .sf-image {
      width: 5rem;
    }
  }

  .list-price {
    align-items: center;
    justify-content: space-between;
  }
}
.orderNote {
  .sf-textarea__error-message {
    display: none;
  }
}
@include for-mobile {
  .OrderNoteRow {
    flex-direction: column;
    .sf-property__name {
      margin-bottom: var(--spacer-sm);
    }
    textarea {
      width: 90%;
    }
  }
  .emailRow{
    flex-direction: column;
    .sf-property__name {
      margin-bottom: var(--spacer-sm);
    }
  }
}
</style>
